// types
import { User } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import {
	Avatar,
	AvatarProps,
	Grid,
	GridProps,
	Tooltip,
	TooltipProps,
	Typography,
	TypographyProps,
} from '@mui/material';

// ui
import { TypographyOverflow } from '../TypographyOverflow/TypographyOverflow';

// props
export interface UserAvatarProps {
	AvatarProps?: AvatarProps;
	caption?: TypographyProps;
	GridProps?: GridProps;
	TooltipProps?: Omit<TooltipProps, 'children'>;
	TypographyProps?: TypographyProps;
	user: null | Partial<User>;
}

export const UserAvatar = ({
	AvatarProps,
	caption,
	GridProps,
	TooltipProps,
	TypographyProps,
	user,
}: UserAvatarProps) => {
	// hooks
	const { t } = useTranslation();

	let name = t('na');

	if (user) {
		if (user.firstName && user.lastName) {
			name = `${user.firstName} ${user.lastName}`;
		} else if (user.firstName) {
			name = user.firstName;
		}
	}

	const avatar = <Avatar sx={{ width: 24, height: 24 }} {...AvatarProps} />;

	return (
		<Grid alignItems="center" container spacing={1} wrap="nowrap" {...GridProps}>
			<Grid item sx={{ display: { xs: 'none', lg: 'flex' } }} xs="auto">
				<Tooltip placement="top" title={name} {...TooltipProps}>
					{avatar}
				</Tooltip>
			</Grid>
			<Grid item xs={true} sx={{ minWidth: 0, overflow: 'hidden' }}>
				<TypographyOverflow component="div" variant="caption" {...TypographyProps}>
					{name}
				</TypographyOverflow>
				{caption && (
					<Typography color="brand.grey.500" component="div" variant="caption" {...caption} />
				)}
			</Grid>
		</Grid>
	);
};
